"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _Alert = require("./Alert.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Alert = function Alert(_ref) {
  var children = _ref.children,
    content = _ref.content,
    heading = _ref.heading,
    rounded = _ref.rounded,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type;
  return /*#__PURE__*/_react.default.createElement(_Alert.Wrapper, {
    "data-key": "max-alert",
    type: type.toLowerCase(),
    rounded: rounded
  }, /*#__PURE__*/_react.default.createElement(_Alert.Flex, null, children ? /*#__PURE__*/_react.default.createElement(_Alert.InnerWrapper, {
    "data-key": "max-alert__children"
  }, children) : /*#__PURE__*/_react.default.createElement(_Alert.InnerWrapper, {
    "data-key": "max-alert__children"
  }, /*#__PURE__*/_react.default.createElement(_typography.P, {
    size: "xs",
    disableMargin: true
  }, heading && /*#__PURE__*/_react.default.createElement(_Alert.Heading, {
    "data-key": "max-alert__heading"
  }, "".concat(heading, " ")), /*#__PURE__*/_react.default.createElement("span", {
    "data-key": "max-alert__content"
  }, content)))));
};
var _default = Alert;
exports.default = _default;